<template>
  <div class="need-details mt-4">
    <h3 class="text-center">Need Notes</h3>

    <div class="d-flex align-center">
      <div class="font-weight-bold align-self-start mr-4">Main need:</div>

      <div v-if="needsList && needsList.length > 0">
        <div v-for="(type, k) in needsList" :key="k">
          {{ needTextByType(type, needs[type]) }}
        </div>
      </div>
    </div>

    <div>
      <span class="font-weight-bold"> Beneficiary: </span>
      <span> {{ beneficiaryDetails }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { needTextByType } from '@/common/helpers';

export default {
  name: 'PlateNeedDetails',
  props: {
    beneficiary: Object,
    lead: Object,
  },
  computed: {
    ...mapGetters({
      needs: 'plates/needs',
      needsList: 'plates/needsList',
    }),

    beneficiaryDetails() {
      const isLiveInSameState = this.beneficiary.liveInSameState
        ? `Leaves in ${this.lead.state}`
        : 'Leaves out of state';

      const isAnyGrandchildren = this.beneficiary.grandchildrenAmount
        ? `- ${this.beneficiary.grandchildrenAmount} Grandkids`
        : '';

      const nonSpouseText =
        this.beneficiary.relationship !== 'spouse'
          ? `- ${isLiveInSameState} ${isAnyGrandchildren}`
          : '';

      return `${this.beneficiary.relationship} - ${this.beneficiary.name} ${nonSpouseText}`;
    },
  },
  methods: {
    needTextByType,
  },
};
</script>

<style scoped lang="scss">
.need-details {
  padding: 20px 30px;
  border: 1px solid black;
}
</style>
